<template>
    <v-card>
        <v-form
            ref="identityForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading || presetIdentity"
                                :rules="[validRSAID,requiredRule,lengthRule(20)]"
                                label="Identification Number"
                                ref="idNumber"
                                v-model="identity.identificationNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="identityTypes"
                                :rules="[requiredRule]"
                                @input="$refs.identityForm.validate()"
                                item-text="value"
                                item-value="key"
                                label="Identity Type"
                                v-model="identity.identityTypeId"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-btn
                                :disabled="isLoading || isVerifyingRsaId"
                                :loading="isVerifyingRsaId"
                                @click="verifyRsaId"
                                class="text-none"
                                color="light-blue darken-1"
                                dark
                                v-if="identity.identityTypeId == 1 || identity.identityTypeId == 4"
                            >
                                <v-icon
                                    dark
                                    left
                                >mdi-account</v-icon>Verify RSA ID
                            </v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="identity.identityTypeId != 1 && identity.identityTypeId != 4"
                        >
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="dateMenuDocExpiration"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        label="Identity Doc Expiration Date"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-model="identity.idDocExpirationDate"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="dateMenuDocExpiration = false"
                                    v-model="identity.idDocExpirationDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col
                            cols="12"
                            v-show="identity.identityTypeId != 1 && identity.identityTypeId != 4"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[(identity.identityTypeId != 1 && identity.identityTypeId != 4)?requiredRule:()=>true,lengthRule(50)]"
                                label="Identity Doc Place Of Issue"
                                v-model="identity.idDocPlaceOfIssue"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="dateMenuDoB"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        label="Date Of Birth"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-model="identity.dateOfBirth"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="dateMenuDoB = false"
                                    v-model="identity.dateOfBirth"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col
                            cols="4"
                            lg="2"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(20)]"
                                label="Title"
                                v-model="identity.title"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="8"
                            lg="5"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(20)]"
                                label="Name"
                                v-model="identity.name"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            lg="5"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(20)]"
                                label="Surname"
                                v-model="identity.surname"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(50)]"
                                label="Email"
                                v-model="identity.email"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(20)]"
                                label="Phone"
                                v-model="identity.phone"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                :disabled="isLoading"
                                class="mb-0"
                                label="Identity Document Available"
                                v-model="identity.idDocumentAvailable"
                                v-show="!identity.idDocumentFileId && !identityDocument"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                :disabled="isLoading"
                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                label="Identity Document"
                                placeholder="Set Identity Document"
                                ref="identityDocumentFileInput"
                                v-model="identityDocument"
                            >
                                <template slot="append-outer">
                                    <v-btn
                                        @click.stop="
                                                    getFile(
                                                        identity.idDocumentFileId,
                                                        'identity_' +
                                                            identity.id +
                                                            '_identitydocument_' +
                                                            identity.idDocumentFileId
                                                    )
                                                "
                                        elevation="1"
                                        fab
                                        small
                                        v-show="
                                                    identity.idDocumentFileId >
                                                    0
                                                "
                                    >
                                        <h3>
                                            <v-icon color="light-blue">mdi-download</v-icon>
                                        </h3>
                                    </v-btn>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col
                            cols="12"
                            v-show="
                            !identityDocumentAvailable"
                        >
                            <div style="color:red">Identity document file or availability required.</div>
                        </v-col>
                        <v-divider></v-divider>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(100)]"
                                label="Address Line 1"
                                v-model="identity.addressLine1"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(100)]"
                                label="Address Line 2"
                                v-model="identity.addressLine2"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(100)]"
                                label="Address Line 3"
                                v-model="identity.addressLine3"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(30)]"
                                label="City"
                                v-model="identity.city"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(30)]"
                                label="Province"
                                v-model="identity.province"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[lengthRule(30)]"
                                label="PostalCode"
                                v-model="identity.postalCode"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <!--<v-btn
                        v-show="hideDelete !== true"
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="identity.id > 0"
                        >Delete</v-btn>-->
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >{{identity.id > 0 ? "Update" : "Add"}}</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>

        <v-dialog
            persistent
            v-model="showVerifiedRsaIdForm"
            width="350px"
        >
            <v-card>
                <v-card-title>Verified RSA ID</v-card-title>
                <v-card-subtitle v-if="verifiedRsaIdDetails">
                    <div
                        class="red--text"
                        v-show="verifiedRsaIdDetails && verifiedRsaIdDetails.deceased === true"
                    >
                        <br />
                        Deceased: {{
                        dateToString(
                        verifiedRsaIdDetails.deceasedDate ? new Date(verifiedRsaIdDetails.deceasedDate) : null)
                        }}
                    </div>
                    <br />
                    Names: {{verifiedRsaIdDetails.firstnames}}
                    <br />
                    Surname: {{verifiedRsaIdDetails.lastname}}
                    <br />
                    DoB: {{verifiedRsaIdDetails.dateOfBirth}}
                </v-card-subtitle>
                <v-card-actions>
                    <v-btn
                        @click="verifiedRsaIdFormClose"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                    <v-btn
                        @click="verifiedRsaIdPopulate"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Populate</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import Identity from "../../models/Identity.model";
import dateToString from "../../helpers/dateToString";
export default {
    props: {
        identityIn: Identity,
        autoClose: Boolean,
        presetIdentity: Boolean,
        hideDelete: Boolean
    },
    components: {
        //
    },
    mounted: async function() {
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
    },
    computed: {
        identityDocumentAvailable: function() {
            if (this.identity.idDocumentFileId > 0) return true;

            if (!!this.identityDocument || this.identity.idDocumentAvailable)
                return true;

            return false;
        }
    },
    data() {
        return {
            identityTypes: null,
            identity: this.loadIdentity(this.identityIn),
            identityDocument: null,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isVerifyingRsaId: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            dateMenuDocExpiration: false,
            dateMenuDoB: false,
            requiredRule: v => !!v || "required",
            validRSAID: v => {
                if (
                    this.identity.identityTypeId != 1 &&
                    this.identity.identityTypeId != 4
                )
                    return true;

                var invalidId = "Invalid RSA ID";
                if (!v || v.length != 13) return invalidId;

                var idNumbers;
                try {
                    idNumbers = v.split("").map(x => parseInt(x));
                } catch {
                    return invalidId;
                }

                if (idNumbers[10] > 1) return invalidId;

                var evens = [
                    idNumbers[1],
                    idNumbers[3],
                    idNumbers[5],
                    idNumbers[7],
                    idNumbers[9],
                    idNumbers[11]
                ];

                var odds = [
                    idNumbers[0],
                    idNumbers[2],
                    idNumbers[4],
                    idNumbers[6],
                    idNumbers[8],
                    idNumbers[10],
                    idNumbers[12]
                ];

                var evensLuhnSum = evens
                    .map(x => {
                        var d = 2 * x;
                        if (d > 9) {
                            var dstring = d.toString();
                            d = parseInt(dstring[0]) + parseInt(dstring[1]);
                        }
                        return d;
                    })
                    .reduce((a, b) => a + b, 0);

                var oddsSum = odds.reduce((a, b) => a + b, 0);

                return (evensLuhnSum + oddsSum) % 10 == 0 || invalidId;
            },
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",

            verifiedRsaIdDetails: null,
            showVerifiedRsaIdForm: null
        };
    },

    methods: {
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        dateToString,
        //loadIdentity -------------------------------
        loadIdentity(loadIdentity) {
            var toLoad = new Identity().set(loadIdentity);

            toLoad.dateOfBirth = dateToString(
                toLoad.dateOfBirth ? new Date(toLoad.dateOfBirth) : null
            );

            toLoad.idDocExpirationDate = dateToString(
                toLoad.idDocExpirationDate
                    ? new Date(toLoad.idDocExpirationDate)
                    : null
            );

            return toLoad;
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedIdentity) {
            this.$emit("saved", savedIdentity);
            if (this.autoClose) this.$emit("close");
        },
        emitDeletedEntity(deletedIdentity) {
            this.$emit("deleted", deletedIdentity);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.identityForm.validate();
            return this.isValid && this.identityDocumentAvailable;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("IdDocument", this.identityDocument);
                formdata.append("Model", JSON.stringify(this.identity));

                const parameters = {
                    id: this.identity.id,
                    formData: formdata
                };
                this.$store
                    .dispatch(
                        "identities/" +
                            (this.identity.id == 0 ? "create" : "update"),
                        this.identity.id == 0 ? parameters.formData : parameters
                    )
                    .then(
                        identityWithInfo => {
                            this.notify(
                                "Identity successfully saved.",
                                "success"
                            );
                            if (this.identity.id == 0) {
                                this.identity.id = identityWithInfo.entity.id;
                            }
                            this.emitSavedEntity(identityWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this identity?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("identities/delete", this.identity.id)
                    .then(
                        () => {
                            this.notify(
                                "Identity successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.identity);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        //verifyRsaId ------------------------------------------------------------
        verifyRsaId() {
            var validCheck = this.validRSAID(
                this.identity.identificationNumber
            );

            if (validCheck === true) {
                this.isLoading = true;
                this.isVerifyingRsaId = true;

                this.$store
                    .dispatch(
                        "identities/verifyRsaId",
                        this.identity.identificationNumber
                    )
                    .then(
                        response => {
                            if (response.data) {
                                this.verifiedRsaIdDetails = response.data;

                                this.verifiedRsaIdDetails.dateOfBirth = dateToString(
                                    this.verifiedRsaIdDetails.dateOfBirth
                                        ? new Date(
                                              this.verifiedRsaIdDetails.dateOfBirth
                                          )
                                        : null
                                );
                                this.showVerifiedRsaIdForm = true;
                            } else
                                this.notify(
                                    "Provided RSA ID failed verification check.",
                                    "error"
                                );
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.verifyRsaIdDone);
            } else {
                this.notify(validCheck, "error");
            }
        },
        verifyRsaIdDone() {
            this.isLoading = false;
            this.isVerifyingRsaId = false;
        },
        verifiedRsaIdFormClose() {
            this.showVerifiedRsaIdForm = false;
            this.verifiedRsaIdDetails = null;
        },
        verifiedRsaIdPopulate() {
            this.identity.name = this.verifiedRsaIdDetails.firstnames;
            this.identity.surname = this.verifiedRsaIdDetails.lastname;
            this.identity.dateOfBirth = this.verifiedRsaIdDetails.dateOfBirth;
            this.identity.gender = this.verifiedRsaIdDetails.gender;
            this.verifiedRsaIdFormClose();
        }
    }
};
</script>

<style lang="stylus" scoped></style>